<template>
  <div class="ws-button-card">
    <WsText001
      v-if="cardTitle"
      h5
      bold
    >
      {{ cardTitle }}
    </WsText001>
    <div
      class="button-card_content mt-10"
      :class="{white:white}"
    >
      <WsText001
        class="text"
        h5
      >
        {{ contentText }}
      </WsText001>
      <div class="btn">
        <slot name="btn" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "WsButtonCard001",
  props: {
    outlineButton: {
      type: Boolean,
      default: false,
    },
    cardTitle: {
      type: String,
      default: "",
    },
    white: {
      type: Boolean,
      default: false,
    },
    contentText: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss" scoped>
.ws-button-card {
  .button-card_content {
    @include auto_margin_top(10px);
    padding: 20px;
    border-radius: 10px;
    border: solid 1px #d8d8d8;
    &.white {
      border: none;
      background-color: var(--white);
    }
    .text {
      @include auto_margin_top(10px);
    }
    .btn {
      @include auto_margin_top(20px);
    }
  }
}
</style>